"use client";

import { logger } from "@sa-nu/logger";
import Image from "next/image";
import { useEffect } from "react";

import { SUPPORT_CENTER_INQUIRY_FORM_URL } from "../constants";

import GlobalFooter from "./_components/global-footer";
import { Link } from "./_components/ui/link";

export default function ErrorPage({
  withoutLogo = false,
  error,
}: {
  withoutLogo?: boolean;
  error: Error & { digest?: string };
}) {
  useEffect(() => {
    logger.error(`unhandled error: ${error.message}`, {
      error,
    });
  }, [error]);

  return (
    <div className="flex h-full flex-col md:min-h-screen">
      {!withoutLogo && (
        <Link
          data-analytics-id="error_page_clicked_logo"
          href="/"
          className="absolute top-[20px] left-[30px] md:top-[30px] md:left-[40px]"
        >
          <Image
            src="/i/sanu2ndhome_logo.svg"
            alt="SANU 2nd Home Logo"
            width={129}
            height={19}
          />
        </Link>
      )}
      <div className="bg-slightbeige text-skogecha flex flex-col items-center justify-center gap-y-8 md:flex-1">
        <div className="mt-[100px] mb-[80px] flex w-[320px] max-w-3xl flex-col items-center justify-center gap-y-8 md:w-[690px] md:gap-y-[60px]">
          <h1 className="text-left text-2xl font-semibold tracking-wide md:text-3xl">
            500 Server Error
            <br />
            サーバーに問題が発生しました。
          </h1>
          <p className="text-left text-sm leading-relaxed md:text-base">
            しばらくしてからもう一度、お試しください。
            <br />
            お急ぎの場合は、
            <Link
              data-analytics-id="error_page_clicked_support"
              href={SUPPORT_CENTER_INQUIRY_FORM_URL}
              className="underline"
            >
              サポートセンター
            </Link>
            までお問い合わせください。
          </p>
          <div className="w-[200px] text-center">
            <Link
              data-analytics-id="error_page_clicked_back_home"
              href="/"
              className="btn-primary h-[48px] text-[11px] md:text-[14px]"
            >
              トップページへ戻る
            </Link>
          </div>
        </div>
      </div>
      <div className="w-full">
        <GlobalFooter />
      </div>
    </div>
  );
}
